import { bootstrap } from '../lib/bootstrap';
import { apolloClientSanityQuery } from '../lib/core/useSanityQuery';
import {
  SANITY_TERMS_OF_PURCHASE_QUERY,
  useSanityTermsOfPurchase
} from '../lib/sanity/useSanityTermsOfPurchase';
import { CustomNextPage } from '../lib/types';
import Article from '../modules/Article';
import Layout from '../modules/Layout';
import { TermsOfPurchasePageQuery } from '../types/sanity-types';

const TermsOfPurchasePage: CustomNextPage<{
  statusCode?: number;
}> = props => {
  const { url, statusCode } = props;
  const termsOfPurchasePageQueryResult = useSanityTermsOfPurchase();

  const { data, loading } = termsOfPurchasePageQueryResult;

  return (
    <Layout
      statusCode={statusCode}
      title={data?.title}
      url={url}
      loading={loading}
      render={({ appContent }) => {
        if (!data) {
          const err = new Error('Terms of purchase page not found');
          err.code = 'ENOENT';
          throw err;
        }
        return (
          <Article
            data={{
              slugsByLocale: null,
              title: data.title,
              file: data.file || null,
              heading: data.heading || null,
              intro: data.intro || null,
              introAlignment: data.introAlignment || null,
              content: data.content || null,
              contentAlignment: data.contentAlignment || null
            }}
            appContent={appContent}
          />
        );
      }}
    />
  );
};

TermsOfPurchasePage.getInitialProps = async ctx => {
  const termsOfPurchasePageQueryResult = await apolloClientSanityQuery<
    TermsOfPurchasePageQuery
  >(ctx, { query: SANITY_TERMS_OF_PURCHASE_QUERY });
  let statusCode: number | undefined;
  if (!termsOfPurchasePageQueryResult.data) {
    statusCode = 404;
    if (ctx.res) {
      // eslint-disable-next-line require-atomic-updates
      ctx.res.statusCode = statusCode;
    }
  }

  return { statusCode };
};

export default bootstrap(TermsOfPurchasePage);
